/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tab',
    template: '<ng-container *ngIf="active"><ng-content></ng-content></ng-container>',
    styleUrls: ['./tab.component.scss']
})

export class TabComponent {
    /**
     * To store the tab title.
     */
    @Input() public tabTitle: string = '';

    /**
     * Translate the tab title.
     */
    @Input() public translateTabTitle: boolean = true;

    /**
     * A boolean to determine if the tab is active.
     */
    @Input() public active: boolean = false;

    /**
     * A boolean to determine if the tab is disabled.
     */
    @Input() public disabled: boolean = false;

    /**
     * To store the tab id.
     */
    @Input() public id: string = '';

    /**
     * Icon location.
     */
    @Input() public iconLocation: string;

    /**
     * Icon alignment with title.
     */
    @Input() public iconAlignment: 'left' | 'right' = 'right';

    /**
     * Apply class to icon.
     */
    @Input() public iconStyle: string;
}
